import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
    {
        n: "01",
        title: "Radikale Klarheit",
        text: "Design beginnt dort, wo alles Überflüssige verschwindet. Jede Entscheidung folgt einer Idee — nicht einem Trend.",
    },
    {
        n: "02",
        title: "Emotionale Präzision",
        text: "Gute Gestaltung ist kein Zufall. Sie ist das Ergebnis aus Handwerk, Haltung und dem Mut, Gefühle sichtbar zu machen.",
    },
    {
        n: "03",
        title: "Handwerk der Zukunft",
        text: "Klassisches Designverständnis trifft auf neue Medien. So entstehen Identitäten, die heute wirken und morgen bestehen.",
    },
];

export default function Manifesto() {
    return (
        <section data-testid="manifesto-section" className="mx-auto max-w-[1600px] px-5 py-28 sm:px-10 sm:py-40">
            <Reveal>
                <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-[#E63946]">Das Manifest</p>
                <h2 className="mb-16 max-w-3xl font-display text-4xl font-bold uppercase leading-none tracking-tight text-[#F4F4F0] sm:text-6xl">
                    Gestaltung mit <span className="text-stroke">Haltung</span>
                </h2>
            </Reveal>
            <div>
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.n} delay={i * 0.08}>
                        <div
                            data-testid={`manifesto-chapter-${c.n}`}
                            className="group grid grid-cols-12 items-start gap-4 border-t border-white/10 py-10 transition-colors duration-500 hover:border-[#E63946]/60 sm:py-14"
                        >
                            <span className="col-span-2 font-mono text-sm text-[#E63946] sm:col-span-1">{c.n}</span>
                            <h3 className="col-span-10 font-display text-2xl font-bold uppercase tracking-tight text-[#F4F4F0] transition-transform duration-500 group-hover:translate-x-3 sm:col-span-5 sm:text-4xl">
                                {c.title}
                            </h3>
                            <p className="col-span-10 col-start-3 text-sm leading-relaxed text-[#A1A1AA] sm:col-span-5 sm:col-start-7 sm:text-base">
                                {c.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
